import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from '_actions';
import { CancelButton, ApplyButton } from '_components';
import styles from './CetsDialog.module.css';
import { Modal } from 'react-bootstrap'

class RefreshRequired extends React.Component {


    refresh() {
        window.location.reload();
    }


    render() {
        return (
            <Modal show={true} backdrop='static' keyboard={false} dialogClassName={styles.dialog}>
                <div className={styles.message}>
                    A new version of Sapphire is available. Your browser will be refreshed now.
                </div>
                <div className={styles.buttons}>
                    <span className={styles.button_wrapper}>
                        <ApplyButton size='small' title='Refresh' onClick={() => this.refresh()} />
                    </span>
                </div>

            </Modal>
        );
    }

}

const connectedRefreshRequired = connect(null)(RefreshRequired);
export { connectedRefreshRequired as RefreshRequired };

